export default __webpack_public_path__ + "static/media/product-image2.d401bfc2.png";